package org.multiplatform.kotfolio.di

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.Stable
import kotlinx.collections.immutable.ImmutableMap
import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.PersistentMap
import kotlinx.collections.immutable.persistentMapOf
import kotlinx.collections.immutable.toPersistentMap
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import org.koin.core.module.dsl.createdAtStart
import org.koin.core.module.dsl.new
import org.koin.core.module.dsl.singleOf
import org.koin.core.module.dsl.withOptions
import org.koin.dsl.bind
import org.koin.dsl.module
import org.multiplatform.kotfolio.domain.Blog
import org.multiplatform.kotfolio.domain.usecase.GetLanguageUseCase
import org.multiplatform.kotfolio.domain.usecase.GetTopicForLanguageUseCase
import org.multiplatform.kotfolio.domain.usecase.GetTracksForTopicUseCase
import org.multiplatform.kotfolio.feature.BlogDiscoveryUIModel
import org.multiplatform.kotfolio.models.BlogEnum
import org.multiplatform.kotfolio.util.BlogsRepository
import org.multiplatform.kotfolio.util.PortfolioData

val gatewayModule = module {
    single { new(::BlogsRepository) } withOptions {  createdAtStart() }
    single { PortfolioData } withOptions { createdAtStart() }

    factory { new(::BlogDiscoveryUIModel) }

    single { (::GetLanguageUseCase) (get<BlogsRepository>()::getLanguage) }
    single { (::GetTopicForLanguageUseCase) (get<BlogsRepository>()::getTopic) }
    single { (::GetTracksForTopicUseCase) (get<BlogsRepository>()::getTrack) }

    single { CoroutineScope(SupervisorJob()) }

    single { new(::BlogController) }
    single { new(::WorkController) }
    single { new(::ProjectController) }

    single<IBlog> { new(::BlogRepository) }
}

open class BlogBaseEntity(open val blogEnum: BlogEnum)

@Immutable
data class Work(val index: Int, val title: String, val description: String, val link: String)

@Immutable
data class Project(val src: String, val title: String, val description: String, val url: String, val language: String)

@Immutable
interface IBlog {
    fun getBlogCountMap(): Map<String, Int>
    fun getAllBlog(): PersistentMap<String, List<Blog>>
    fun getAllWork(): PersistentList<Work>
    fun getAllProject(): PersistentList<Project>

    fun deleteBlog(index: Int)
}

class BlogRepository(private val portfolioData: PortfolioData) : IBlog {
    override
    fun getBlogCountMap(): Map<String, Int> = portfolioData.blogList.mapValues { [_, blogs] ->
            blogs.size + blogs.sumOf { it.blogEnum.linkTags.size }
            //portfolioData.blogList.entries.associate { [title, blogs] -> title to (blogs.size + blogs.sumOf { it.blogEnum.linkTags.size })
        }

    override
    fun getAllBlog(): PersistentMap<String, List<Blog>> = portfolioData.blogList


    override
    fun getAllWork(): PersistentList<Work> = portfolioData.workList


    override
    fun getAllProject() : PersistentList<Project> = portfolioData.projectList

    override fun deleteBlog(index: Int) {
        //portfolioData.deleteBlog(index)
    }
}

data class BlogState (
    val blogs: ImmutableMap<String, List<Blog>> = persistentMapOf(),
    val isLoading: Boolean = false
)

@Stable
class BlogController(
    iBlog: IBlog,
    scope: CoroutineScope
)  {
    val blogs: StateFlow<BlogState>
        field = MutableStateFlow<BlogState>(BlogState())

    val searchQuery: StateFlow<String>
        field = MutableStateFlow<String>("Flutter")

    //val items: List<Blog> get() = _items
    //_items.removeAt() direct property access

    val getBlogCountMap = iBlog.getBlogCountMap()

    private val getAllBlog = iBlog.getAllBlog()

    init {
        scope.launch {
            updateState()
        }
    }

    private suspend fun updateState() {
        filter(language = "Flutter")

        //_blogs.update { currentState -> currentState.copy(blogs = getAllBlog) }

        /*_blogs.update  {
            val update = it.blogs.toMutableList()
            update.removeAt(0)
            it.copy(
                blogs = update
            )
        }*/

        /*
        //Best way
        _blogs.update {
            val update = it.blogs.toMutableList()
            update.removeAt(0)
            it.copy(
                blogs = update
            )
        }

        //Update
        val itemsCopy = _blogs.value.blogs.toMutableList()
        itemsCopy[1].link = ""
        _blogs.update { currentState -> currentState.copy(blogs = itemsCopy) }

        //Add without apply scope
        val itemsCopy = _blogs.value.blogs.toMutableList()
        itemsCopy.add(Blog(1, "", "", "", ""))
        _blogs.update { currentState -> currentState.copy(blogs = itemsCopy) }

        //Insert / Add
        val newList = mutableListOf<Blog>().apply { addAll(_blogs.value.blogs) }
        newList.add(Blog(1, "", "", "", ""))
        _blogs.value = _blogs.value.copy(blogs = newList)

        //Remove
        val newList = mutableListOf<Blog>().apply { addAll(_blogs.value.blogs) }
        newList.removeAt(0)
        _blogs.value = _blogs.value.copy(blogs = newList)

        _blogs.update {
            it.copy(
                blogs = it.blogs.shuffled(),
                isLoading = false
            )
        }
        _blogs.update {
            it.copy(
                blogs = getAllBlog, isLoading = false
            )
        }*/
    }

    suspend fun filter(language: String) {
        //val matchedBlogs = getAllBlog.filterKeys { it.contains(language, ignoreCase = true) }.toImmutableMap()

        val matchedBlogs = getAllBlog[language]?.let {
            persistentMapOf(language to it)
        } ?: persistentMapOf()

        blogs.emit(blogs.value.copy(blogs = matchedBlogs))
    }

    suspend fun filterBlogsByDescription(
        searchQuery: String
    ) {
        if (searchQuery.isBlank()) {
            filter(language = "Flutter")
            return
        }

        val matchedBlogs = getAllBlog.entries
            .mapNotNull { [category, blogs] ->
                //blogs.asSequence().filter
                //Your original code uses asSequence(), but each category's filter predicate performs several any checks.
                //Since you ultimately call toList(), sequences may not improve performance for ordinary blog lists.
                //The implementation above prioritizes readability.

                val filteredBlogs = blogs.filter { blog ->
                    blog.links.any { [title, _] ->
                        title.contains(searchQuery, ignoreCase = true)
                    } ||
                            blog.blogEnum.description.contains(searchQuery, ignoreCase = true) ||
                            blog.blogEnum.tags.any {
                                it.contains(searchQuery, ignoreCase = true)
                            } ||
                            blog.blogEnum.linkTags.any {
                                it.first.contains(searchQuery, ignoreCase = true)
                            } ||
                            blog.blogEnum.bulletPoints.any {
                                it.contains(searchQuery, ignoreCase = true)
                            } ||
                            blog.blogEnum.name.contains(searchQuery, ignoreCase = true) ||
                            blog.blogEnum.fromTo.contains(searchQuery, ignoreCase = true)
                }

                if (filteredBlogs.isNotEmpty()) {
                    category to filteredBlogs
                } else {
                    null
                }
            }
            .toMap()
            .toPersistentMap()

        blogs.emit(blogs.value.copy(blogs = matchedBlogs))
    }
}

@Stable
class WorkController(
    iBlog: IBlog,
    scope: CoroutineScope)
{
    val works: StateFlow<List<Work>> field = MutableStateFlow(emptyList())

    init {
        scope.launch {
            works.value = iBlog.getAllWork()
        }
    }

    /*fun removeAt() {
        val itemsCopy = _works.value.toMutableList()
        itemsCopy.removeAt(1)
        _works.value = itemsCopy
    }*/
}

@Stable
class ProjectController(private val iBlog: IBlog, private val scope: CoroutineScope) {
    val projects: StateFlow<List<Project>>
        field = MutableStateFlow(emptyList())

    private var projectList : List<Project> = emptyList()

    init {
        scope.launch {
            allProject()
            //getData()
        }
    }

    private fun allProject() {
        scope.launch {

            projectList = iBlog.getAllProject()

            val selectProject = projectList.asSequence().filter { it.language == "Flutter" }.toList()
            projects.value = selectProject
        }
    }

   fun filter(language: String) {
       val selectProject = projectList.asSequence().filter { it.language == language }.toList()
       projects.value = selectProject
    }

    /*private fun getData() {
        tryToExecute(
            productUseCase::getBlocks,
            ::onGetProductListSuccess
        )
    }

    //import org.multiplatform.kotfolio.domain.entity.Products
    private fun onGetProductListSuccess(products: Products) {
        println( products.productlist.size)
    }

     private fun <T> tryToExecute(
        function: suspend () -> T,
        onSuccess: (T) -> Unit,
        inScope: CoroutineScope = scope,
    ): Job {
        return runWithErrorCheck(inScope) {
            val result = function()
            onSuccess(result)
        }
    }

    private fun runWithErrorCheck(
        inScope: CoroutineScope = scope,
        dispatcher: CoroutineDispatcher = Dispatchers.Unconfined,
        function: suspend () -> Unit,
    ): Job {
        return inScope.launch(dispatcher) {
            function()
        }
    }*/
}
